module.exports = __webpack_public_path__ + "img/zahiral.7b1c9436.svg";